
import React, { useContext } from "react";
import { useMsal } from "@azure/msal-react";
import { protectedResources } from "../msalConfig";
import { AuthContext } from "../AuthContext";
import AutocompleteDatasets from './AutocompleteDatasets'

/**
 * The below patter is called render props pattern for using the react hook in class
 * based component.
 */

const AutocompleteDatasetsWrapper = (props) => {

    const contextAuth = useContext(AuthContext);
    const { instance } = useMsal();
    const account = instance.getActiveAccount();
    const request = {
        scopes: protectedResources.databook.scopes,
        account: account,
    };

    return <AutocompleteDatasets instance={instance} account={account} request={request} contextAuth={contextAuth} {...props} 
    navigateToViewAllPage={props.navigateToViewAllPage}
    />
}
export default AutocompleteDatasetsWrapper;
